


























import {Component, Vue} from "vue-property-decorator";

@Component({
  components: {},
})

export default class CheckAgreement extends Vue {
  conservationGuidelinesDialog = false

  agreeAgreement() {
    localStorage.setItem("conservationGuidelines", "1")
    this.$router.push({name: 'login'})
  }

  refuseAgreement() {
    const win = window as any
    win.navigator.app.exitApp();
  }

  yhxy() {
    const str = "https://yzkstest.yong-gang.cn/#/yhxy"
    this.$router.push({name: 'iframe', params: {url: str}})

  }

  yszc() {
    const str = "https://yzkstest.yong-gang.cn/#/yszc"
    this.$router.push({name: 'iframe', params: {url: str}})
  }

  mounted() {
    const a = localStorage.getItem("conservationGuidelines")
    console.log(a)
    if (a != null) {
      localStorage.setItem("conservationGuidelines", "1")
      this.$router.replace({name: 'KeShangSelect'});
      this.$router.push({name: 'login'})
    } else {
      this.conservationGuidelinesDialog = true
    }
  }

}
